import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { type ReactNode, useMemo } from 'react';
import { createPortal } from 'react-dom';

export type PipRootProps = {
  pipWindow: Window;
  children: ReactNode;
};

export function PipRoot({ pipWindow, children }: PipRootProps) {
  const cache = useMemo(() => createCache({ key: 'pip', container: pipWindow.document.head }), [pipWindow]);

  return createPortal(
    <CacheProvider value={cache}>
      <CssBaseline />
      {children}
    </CacheProvider>,
    pipWindow.document.body
  );
}
